// @ts-nocheck
import PropTypes from "prop-types";

const AnimalCards = ({fichas = [], selectedAnimals = [], onAnimalClick}) => {
  return (
    <div className="flex-1 max-w-full">
      <div
        className="grid gap-4"
        style={{gridTemplateColumns: "repeat(4, minmax(0, 1fr))"}}
      >
        {fichas.map(ficha => {
          const isSelected = selectedAnimals.includes(ficha);
          return (
            <button
              type="button"
              key={ficha.id}
              onClick={() => onAnimalClick(ficha)}
              className="rounded-[var(--radius-md)] bg-[var(--color-surface)] p-2 cursor-pointer transition-colors"
              style={{
                border: isSelected ? "2px solid var(--color-warning)" : "1px solid var(--color-border)",
              }}
              aria-pressed={isSelected}
            >
              <img
                alt={ficha.nombre}
                src={ficha.img_f}
                style={{height: "var(--size-25)", width: "100%", objectFit: "contain", marginTop: "var(--space-3)"}}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

AnimalCards.propTypes = {
  fichas: PropTypes.array,
  selectedAnimals: PropTypes.array,
  onAnimalClick: PropTypes.func.isRequired,
};

export default AnimalCards;
